export default __webpack_public_path__ + "static/media/grid.51b0f73e.svg";